import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-8 px-4 py-12 md:grid-cols-2 md:px-8 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50 dark:text-foreground-950">
              <i className="ri-clapperboard-fill text-lg"></i>
            </span>
            <span className="text-lg font-bold text-foreground-950">人间中毒在线</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
            人间中毒在线是一个面向影迷的影视内容展示平台，汇集最新电影资源、详尽剧情介绍与观影资讯，帮助你在海量影片中快速找到想看的电影，发现更多好故事。
          </p>
          <p className="mt-4 text-xs leading-relaxed text-foreground-500">
            温馨提示：本站影片资料均为虚构演示内容，用于产品展示；视频播放区为前端演示，暂未接入真实播放源。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground-900">快速导航</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
            <li>
              <Link to="/" className="transition hover:text-accent-700">
                首页
              </Link>
            </li>
            <li>
              <Link to="/category" className="transition hover:text-accent-700">
                电影分类
              </Link>
            </li>
            <li>
              <Link to="/search" className="transition hover:text-accent-700">
                搜索影片
              </Link>
            </li>
            <li>
              <Link to="/about" className="transition hover:text-accent-700">
                关于我们
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground-900">热门分类</h4>
          <div className="mt-4 flex flex-wrap gap-2">
            {categories.slice(0, 6).map((category) => (
              <Link
                key={category.slug}
                to={`/category?genre=${encodeURIComponent(category.slug)}`}
                className="rounded-full border border-background-300 bg-secondary-100/20 px-3 py-1 text-xs text-secondary-900 transition hover:border-accent-400 hover:text-accent-700"
              >
                {category.name}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-background-200 px-4 py-5 md:px-8">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-between gap-3 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 人间中毒在线 · 保留所有权利</p>
          <p>内容均为虚构演示 · 仅供产品展示使用</p>
        </div>
      </div>
    </footer>
  );
}